exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".planned-activity-row .planned-activity-hour-title{border-bottom-style:solid;border-width:1px;border-color:#dcdcdc;margin-bottom:5px;padding-bottom:3px}.planned-activity-row .planned-activity-hour-title .planned-activity-hour-chips{display:inline-block;border-radius:5px;background-color:#e6e6e6;padding:0 7px}", ""]);

// exports
